/*
* config.js
*
* Description: config.js
*
* This file is part of: "http://apps.sundair.com/", "Sundair-2019"
* Copyright 2018,2019,2020,2021,2022 Sundair GmbH
* Contact:  http://www.sundair.com/
* @author Learek <michael.broeker@sundair.com>
*
*/
/*******************************************************************************
* Config: ENVIRONMENT
*
*/
export let CONF_ENVIRONMENT = "DEV"; // DEV or PROD


/*******************************************************************************
* Config: REST - '3D SECURE INFORMATIONS'
*
*/
export const CONF_3DSECURE_ORIGIN = CONF_ENVIRONMENT === "DEV" ? "https://test-booking2019-2.sundair.com" : "https://sundair.com";


/*******************************************************************************
* Config: 'API BASE URL'
*
*/
// export const CONF_API_BASEURL = "https://sdr-cms-development.herokuapp.com/graphql"; // DEV
export const CONF_API_BASEURL = "https://sdr-cms-test.herokuapp.com/graphql"; // TEST
// export const CONF_API_BASEURL = "https://sdr-cms.herokuapp.com/graphql"; // LIVE
// export const CONF_API_BASEURL = "http://localhost:3000/graphql";


/*******************************************************************************
* Config: MOURNING
* => FlightSearchTab.vue => See style block (Change colors)
* => head.inc.php => style.css, style-mourning.css
*
*/
export let CONF_MOURNING = "false";


/*******************************************************************************
* Config: VERSION/REVISION NUMBER
*
*/
export const CONF_VERSION_NUMBER = "Kayofly"; // based on: r.2697 v0.Z1
export const CONF_REVISIONS_NUMBER = "r.2766";



// WEBPACK FOOTER //
// ./src/config.js